var render, staticRenderFns
var script = {}
import style0 from "./style.vue?vue&type=style&index=0&id=55a351a5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a351a5",
  null
  
)

export default component.exports